import { Box, Container, HStack, Link, Text } from "@chakra-ui/react";

import { siteConfig } from "@/data/site";
import { EdgePrimitive } from "@/design-system/primitives";
import { nvpTokens } from "@/design-system/tokens";
import { useI18n } from "@/i18n";

export function Footer() {
  const { copy } = useI18n();

  return (
    <Box
      as="footer"
      borderTop="1px solid"
      borderColor="whiteAlpha.200"
      bg="rgba(4, 5, 14, 0.94)"
      position="relative"
    >
      <EdgePrimitive tone="blue" left="0" right="0" top="0" opacity={0.34} />
      <Container maxW={nvpTokens.layout.container} py={{ base: 7, md: 8 }}>
        <HStack
          justify="space-between"
          align={{ base: "start", md: "center" }}
          flexDir={{ base: "column", md: "row" }}
          gap={4}
        >
          <HStack gap={5} flexWrap="wrap">
            {siteConfig.storeLinks.map((link) => (
              <Link
                key={link.href}
                href={link.href}
                color="whiteAlpha.700"
                _hover={{ color: "white", textDecoration: "none" }}
              >
                {copy.footer.links.find((item) => item.href === link.href)?.label ??
                  link.label}
              </Link>
            ))}
          </HStack>

          <Text color="whiteAlpha.600" fontSize="sm" textAlign={{ base: "left", md: "right" }}>
            © 2026 {siteConfig.studioName}. {copy.footer.rights}
          </Text>
        </HStack>
      </Container>
    </Box>
  );
}
